import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	CUSTOM_ELEMENTS_SCHEMA,
	Input,
	input,
} from '@angular/core';

import type {
	SbRichTextNode,
	SbRichTextRendererMap,
} from '@storyblok/richtext';

import { ReadMoreComponent } from '@valk-nx/components/ui-read-more/src/lib/read-more';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';

import { renderStoryblokRichText } from './render';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'sb-richtext',
	templateUrl: './rich-text.html',
	imports: [ReadMoreComponent, NgClass, StoryblokDirective, NgTemplateOutlet],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RichTextComponent extends StoryblokRootDirective {
	@Input() listStyle: 'list-checkmarks' | 'list-bullets' = 'list-bullets';
	@Input() isReadMore = false;
	@Input() maxWidth: 'max-w-screen-md' | 'section-inner' | 'max-w-full' =
		'max-w-screen-md';

	content = input<string | SbRichTextNode>('');
	richTextResolvers = input<SbRichTextRendererMap>();

	renderedRichText = computed<string>(() => {
		const content = this.content();
		if (typeof content === 'string') {
			return content;
		} else {
			return renderStoryblokRichText(content, this.richTextResolvers());
		}
	});
}
